import { render, staticRenderFns } from "./ItemHomeListComponent.vue?vue&type=template&id=6b18d545&scoped=true"
import script from "./ItemHomeListComponent.vue?vue&type=script&lang=js"
export * from "./ItemHomeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18d545",
  null
  
)

export default component.exports